//frontend/src/components/Header.js
import React, { useEffect, useState } from 'react';
import UserDropdown from './UserDropdown'; // The component for avatar dropdown
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; // For decoding JWT tokens

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;


const Header = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // Fetch the user data from localStorage (set after Google login)
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      setUser(storedUser);
    } else {
      navigate('/login'); // Redirect to login if no user is found
    }
  }, [navigate]);

  // Load the new Google Identity Services (GIS) for login
  useEffect(() => {
    const handleCredentialResponse = (response) => {
      const data = jwtDecode(response.credential);
      console.log("Google User Data: ", data);
      localStorage.setItem("user", JSON.stringify(data));
      setUser(data);
      navigate("/"); // Redirect after successful login
    };

    // Load Google Identity Services script
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.onload = () => {
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: handleCredentialResponse,
      });
      window.google.accounts.id.renderButton(
        document.getElementById('signInDiv'),
        { theme: 'outline', size: 'large' }
      );
    };
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  // Handle logout logic
  const handleLogout = () => {
    window.google.accounts.id.disableAutoSelect(); // Ensure Google logout works properly

    // Clear cached data
    localStorage.removeItem("user");
    localStorage.removeItem("subscriptions");
    localStorage.removeItem("customerInfo");

    setUser(null);
    navigate("/login"); // Redirect to login page

    // Reload the page to ensure all cached state is reset
    window.location.reload();
  };


  return (
    <div className="bg-white text-gray-800">
      <header className="container bg-white p-4 flex justify-between items-center">
        <div className="flex items-center">
          <div className="logo-container">
            <img
              src="https://cloudfresh.com/wp-content/themes/techsvit/img/png/logo-black-cl.svg"
              alt="Logo"
              className="w-36 h-auto"
            />
          </div>
          <span class="separator"></span>
          <div className="app-name">Google Workspace License Manager</div>
        </div>
        {/* Display the login button or avatar dropdown depending on user's login status */}
        {user ? (
          <UserDropdown user={user} onLogout={handleLogout} />
        ) : (
          <div id="signInDiv"></div> // Render Google sign-in button here
        )}
      </header>
    </div>
  );
};

export default Header;
